export default __webpack_public_path__ + "static/media/disableSettingIcon.e1003035.svg";